import {ActionContext, Module} from 'vuex';
import RootState from '@/store/rootState';

export interface AutosaveState {
    lastStatus?: number;
    saving: boolean;
    error?: string;
}

type AutosaveContext = ActionContext<AutosaveState, RootState>;

const autosave: Module<AutosaveState, RootState> = {
    namespaced: true,

    state: {
        saving: false,
    },

    actions: {
        async autosave({ rootState, dispatch, commit }: AutosaveContext) {
            if (!rootState.project.dirty) {
                return;
            }
            console.debug('Starting autosave...');
            commit('AUTOSAVE_RESET');
            try {
                await dispatch('project/updateFiles', undefined, { root: true });
                if (process.env.NODE_ENV === 'test') {
                    await new Promise((r) => setTimeout(r, 100));
                } else {
                    await new Promise((r) => setTimeout(r, 2000));
                }
            } catch (e) {
                console.error(e);
                commit('AUTOSAVE_ERROR', e.message);
            }
            commit('AUTOSAVE_FINISH');
            console.debug('Project autosaved.');
        },
    },

    mutations: {
        AUTOSAVE_RESET(state: AutosaveState) {
            state.saving = true;
            state.error = undefined;
        },

        AUTOSAVE_ERROR(state: AutosaveState, error: string) {
            state.error = error;
        },

        AUTOSAVE_FINISH(state: AutosaveState) {
            state.lastStatus = Date.now();
            state.saving = false;
        },
    },
};

export default autosave;
